import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

import { NgxPermissionsModule } from 'ngx-permissions';
import { provideToastr } from 'ngx-toastr';

import { environment } from '@env/environment';

import { routes } from './app.routes';
import { AuthInterceptor } from './core/http/auth.interceptor';
import { BASE_URL } from './core/http/base-url.token';
import { QzTrayService } from './core/printing/qz-tray.service';
import { LegacyStorageBridge } from './legacy-storage-bridge';

export const appConfig: ApplicationConfig = {
  providers: [
    // Before routing: carries a signed-in user's old storage keys over to the pos.* keys.
    provideAppInitializer(() => inject(LegacyStorageBridge).run()),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: BASE_URL, useFactory: () => `${environment.posApiBaseUrl}/` },
    provideAnimationsAsync(),
    provideToastr({ preventDuplicates: true }),
    provideNativeDateAdapter(),
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    DatePipe,
    QzTrayService
  ]
};
